'use client'

import { useState } from 'react'
// import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog'
// import { PlayerCardModal } from './player-card-modal'
import { Button } from '@/components/ui/button'
// import { useQuery } from '@tanstack/react-query'
import { usePlayerModal } from '@/lib/providers/player-modal-provider'

interface PlayerLinkProps {
    playerId: number
    playerName: string
    className?: string
    // Optional navigation props
    navigationData?: {
        playerIds: number[]
        context?: string // e.g., "team-roster", "search-results", etc.
    }
}

export function PlayerLink({ playerId, playerName, className, navigationData }: PlayerLinkProps) {
    // const [isOpen, setIsOpen] = useState(false)
    // const { data: player, isLoading } = useQuery({
    //     queryKey: ['player', playerId],
    //     queryFn: async () => {
    //         const response = await fetch(`/api/player/${playerId}`)
    //         if (!response.ok) {
    //             throw new Error('Failed to fetch player details')
    //         }
    //         return response.json()
    //     },
    //     enabled: isOpen, // Only fetch when modal is opened
    // })
    const { openPlayerModal, openPlayerModalWithNavigation } = usePlayerModal()

    const handleClick = () => {
        if (navigationData?.playerIds && navigationData.playerIds.length > 1) {
            openPlayerModalWithNavigation(playerId, navigationData.playerIds)
        } else {
            openPlayerModal(playerId)
        }
    }

    return (
        <Button
            variant="link"
            className={className}
            onClick={handleClick}
            aria-label={`Player name: ${playerName}`}
        >
            {playerName}
        </Button>
        // <Dialog open={isOpen} onOpenChange={setIsOpen}>
        //     <DialogTrigger asChild>
        //         <Button
        //             variant="link"
        //             className={className}
        //             aria-label={`Player name: ${playerName}`}
        //         >
        //             {playerName}
        //         </Button>
        //     </DialogTrigger>
        //     <DialogContent className="max-w-none w-screen h-screen p-0 border-0">
        //         <PlayerCardModal
        //             playerId={playerId}
        //             onClose={() => setIsOpen(false)}
        //         />
        //     </DialogContent>
        // </Dialog>
    )
} 